import { ApiUser } from '@/types/user';

export const canUseAdminFeatures = (user: ApiUser | undefined | null) => {
  if (user?.rights && user.rights.length > 0) {
    return user.rights.map((right) => right.name).includes('can_impersonate');
  }
  return false;
};
